const newMenu = [
  {
    id: 1,
    title: "salt & pepper chicken",
    description:
      "The excellence of our Salt & Pepper Chicken, They're then gently coated in a seasoned, Tender marinated chicken, lightly coated for a crispy, ' flavourful bite.'",
    category: "APPETISER 🥢",
    image: "/Photos/Menu01042024/appetiser_salt_pepper_chicken.jpeg",
    vegan: false,
    vegetarian: false,
    contains: "gluten,soybeans,egg",
  },
  {
    id: 2,
    title: "Vegetable Spring Roll (4pcs)",
    description:
      "Crispy on the outside, A delightful fusion of crunch and garden-fresh flavours on the inside.",
    category: "APPETISER 🥢",
    image: "/Photos/Menu01042024/appretiser_vegetable_spring_rolls.jpeg",
    vegan: true,
    vegetarian: true,
    contains: "gluten,soybeans,Vegan",
  },
  {
    id: 3,
    title: "Edamame",
    description:
      "These vibrant green, vegan-friendly soya bean pods are seasoned with a delicate touch of sea-salt. A perfect blend of freshness and flavour awaits you.",
    category: "APPETISER 🥢",
    image: "/Photos/Menu01042024/appretiser_edamame.jpeg",
    vegan: true,
    vegetarian: true,
    contains: "soybeans,Vegan",
  },
  {
    id: 4,
    title: "Thai Chicken Wings",
    description:
      "Crispy -fried to perfection and generously seasoned with a mouth-watering blend of garlic, five-spice, chili, onions, spring onions, salt, pepper, and bursting with vibrant Thai flavours.",
    category: "APPETISER 🥢",
    image: "/Photos/Menu01042024/appretiser_thai_chicken_wings.jpeg",
    vegan: false,
    vegetarian: false,
    contains: "gluten,milk,sesame,soybeans",
  },
  {
    id: 5,
    title: "Sweet Chilli Chicken ✨NEW✨",
    description:
      "Savor the fusion of Korean-style sweet chili chicken-tender bites glazed for a perfect balance of spice and sweetness, topped with the freshness of spring onions.",
    category: "APPETISER 🥢",
    image: "/Photos/Menu01042024/appretiser_sweetchilli_chicken_wings.jpeg",
    vegan: false,
    vegetarian: false,
    contains: "eggs,gluten,milk,sesame,soybeans",
  },
  {
    id: 6,
    title: "Chicken Gyoza (5pcs)",
    description:
      "Delight in our Chicken Gyoza with reveal a seasoned chicken filling that's savoury and satisfying with every bite. A must-try for gyoza enthusiasts.",
    category: "APPETISER 🥢",
    image: "/Photos/Menu01042024/appretiser_chicken_gyoza.jpeg",
    vegan: false,
    vegetarian: false,
    contains: "gluten,sesame,soybeans",
  },
  {
    id: 7,
    title: "Duck Spring Roll (5pcs)",
    description:
      "A delightful twist with tender, five-spice roasted duck With every bite, you'll encounter the perfect balance of crunch and rich, aromatic flavours.",
    category: "APPETISER 🥢",
    image: "/Photos/Menu01042024/appretiser_duck_spring_rolls.jpeg",
    vegan: false,
    vegetarian: false,
    contains: "gluten,sesame,soybeans",
  },
  {
    id: 8,
    title: "Prawn Tempura (5pcs)",
    description:
      "Crispy tempura perfection with succulent king prawns , choice for seafood enthusiasts and tempura connoisseurs.",
    category: "APPETISER 🥢",
    image: "/Photos/Menu01042024/appretiser_prawn_tempura.jpeg",
    vegan: false,
    vegetarian: false,
    contains: "gluten,crustaceans,sesame",
  },
  {
    id: 9,
    title: "Salt & Pepper Calamari",
    description:
      "Adventure with our Salt & Pepper Calamari. These delectable morsels, crispy texture are generously tossed in a flavourful medley of salt, pepper, chili, and spring onions. Every bite offers a thrilling fusion.",
    category: "APPETISER 🥢",
    image: "/Photos/Menu01042024/appretiser_salt_pepper_calarmari.jpeg",
    vegan: false,
    vegetarian: false,
    contains: "eggs,molluscs,soybeans",
  },
  {
    id: 10,
    title: "Prawn Toast (5pcs)",
    description:
      "A harmonious blend of crispy, savoury perfection where succulent prawns and fragrant sesame seeds come together in a delightful appetize.",
    category: "APPETISER 🥢",
    image: "/Photos/Menu01042024/appretiser_prawn_toast.jpeg",
    vegan: false,
    vegetarian: false,
    contains: "gluten,sesame,soybeans",
  },
  {
    id: 11,
    title: "Vegetable Gyoza (5pcs)",
    description:
      "Crispy and savoury deep-fried dumplings are generously filled with fresh vegetables and protein-rich soybeans, offering a mouth-watering fusion of taste and nutrition.",
    category: "APPETISER 🥢",
    image: "/Photos/Menu01042024/appretiser_chicken_gyoza.jpeg",
    vegan: true,
    vegetarian: true,
    contains: "gluten,soybeans,Vegan",
  },
  {
    id: 12,
    title: "Tom Yum (Medium) 450 ml",
    description:
      "Experience The flavours of Thailand with our Tom Yum soup is a delightful blend of tangy and savoury, filled with crisp cabbage, earthy mushrooms, tender lettuce, vibrant broccoli, fresh coriander, and tomatoes. Each bite is an authentic journey through Thailand",
    category: "Sip & Savor Soups",
    image: "/Photos/Menu01042024/sip_tom_yum.jpeg",
    vegan: false,
    vegetarian: false,
    contains: "soybeans",
  },
  {
    id: 13,
    title: "Tom Kha (Mild) 450 ml",
    description:
      "This Thai-style broth, with a mild blend of spiciness and tanginess, is luxuriously enriched with coconut milk, tender cabbage, broccoli, fresh coriander, and earthy mushrooms. Each spoonful invites you on a journey to Thailand.",
    category: "Sip & Savor Soups",
    image: "/Photos/Menu01042024/sip_tom_kha.jpeg",
    vegan: true,
    vegetarian: true,
    contains: "soybeans",
    options: "Vegan",
  },
  {
    id: 14,
    title: "Miso (450 ml)",
    description:
      "A traditional Japanese delight with rich flavours of white miso, tofu, seaweed, and spring onions. Experience that's both authentic and delightful.",
    category: "Sip & Savor Soups",
    image: "/Photos/Menu01042024/sip_miso.jpeg",
    vegan: false,
    vegetarian: false,
    contains: "soybeans",
  },
  {
    id: 15,
    title: "Thai Crunch Peanut Dressing Salad (Mild)",
    description:
      "Flavourful feast. It features crisp cucumber, edamame beans, shredded carrot, lettuce, and colourful peppers, all bathed in our luscious peanut dressing with a touch of soy sauce. Personalize your salad with either tender chicken or hearty tofu.",
    category: "Salad",
    image: "/Photos/Menu01042024/salad_thai_crush_peanut.jpeg",
    vegan: true,
    vegetarian: true,
    contains: "peanuts, soybeans, sesame, gluten",
    options: "Chicken,Tofu Vegan, Vegan",
  },
  {
    id: 16,
    title: "Seaweed Salad",
    description:
      "A unique blend of briny umami flavours with a touch of sweetness, complemented by toasted sesame seeds.",
    category: "Salad",
    image: "/Photos/Menu01042024/salad_seaweed.jpeg",
    vegan: true,
    vegetarian: true,
    contains: "",
    options: "Vegan",
  },
  {
    id: 17,
    title: "Pho (Vietnamese Favourite)",
    description:
      "The aromatic and complex flavours of our Pho. combines with fragrant rice noodles, ginger, the star anise, and the richness of cardamom, including crisp beansprouts, tender shreds of carrot, chilies, spring onions, a slice of lime, and coriander. Each spoonful is a journey through the heart of Vietnamese.",
    category: "Noodle Soup (Big bowl)",
    image: "/Photos/Menu01042024/noodle_soup_vietnamese_pho.jpeg",
    vegan: true,
    vegetarian: true,
    contains: "fish, gluten, milk, sesame, Vegan",
  },
  {
    id: 18,
    title: "Ramen (Japanese Favourite)",
    description:
      "This heart-warming bowl offers a delightful array of ingredient, tender boiled egg, springy ramen noodles, fish cake, dashi, fragrant seaweed, fresh spring onions, dried mushrooms, and a hint of fish sauce. Each spoonful captures the rich culinary tradition of Japan.",
    category: "Noodle Soup (Big bowl)",
    image: "/Photos/Menu01042024/noodle_soup_japanese_ramen.jpeg",
    vegan: false,
    vegetarian: false,
    contains: "eggs, fish, gluten, soybeans",
    options: "Tempura Prawn, Roasted Duck, Crispy Chicken",
  },
  {
    id: 19,
    title: "Tom Yum Vermicelli (Medium)",
    description:
      "Experience The flavours of Thailand with our Tom Yum soup, featuring tender rice vermicelli, tomatoes, mushrooms, fragrant coriander, fresh spring onions, crisp beansprouts, and tender shreds of carrot. Each bite is an authentic journey through Thailand.",
    category: "Noodle Soup (Big bowl)",
    image: "/Photos/Menu01042024/noodle_soup_tom_yum_vermecilli.jpeg",
    vegan: false,
    vegetarian: false,
    contains: "soybeans",
    options: "Chicken, Prawn",
  },
  {
    id: 20,
    title: "Tom Kha Vermicelli (Mild)",
    description:
      "Mildly spicy and sour Thai style broth served with thin rice vermicelli noodles, coconut milk, mushroom, spring onions coriander, cabbage, beansprouts and shredded carrot.",
    category: "Noodle Soup (Big bowl)",
    image: "/Photos/Menu01042024/noodle_soup_thom_kha_vermecilli.jpeg",
    vegan: false,
    vegetarian: false,
    contains: "soybeans",
    options: "Chicken, Prawn",
  },
  {
    id: 21,
    title: "Thai Massaman Curry (Medium)",
    description:
      "Indulge in the harmony of flavours in our Mild Spice Coconut Milk Massaman Curry, where tender potatoes, vibrant green and red peppers, aromatic onions, and crisp carrots unite in a creamy symphony of delight.",
    category: "Curry and Rice Dishes (Main)",
    image: "/Photos/Menu01042024/curry_thai_massaman.jpeg",
    vegan: true,
    vegetarian: true,
    contains: "crustaceans",
    options: "Chicken, Prawn, Beef, Tofu, Vegan",
  },
  {
    id: 22,
    title: "Sweet and Sour (Hong Kong Style) Mild",
    description:
      "Immerse yourself in the captivating flavors of our sweet and sour dish. This delightful medley includes broccoli, carrot, pineapple, green and red peppers, onions, and fresh tomato, it's a symphony of tastes that will transport your palate to the bustling streets of Hong Kong.",
    category: "Curry and Rice Dishes (Main)",
    image: "/Photos/Menu01042024/curry_sweet_sour.jpeg",
    vegan: false,
    vegetarian: false,
    contains: "",
    options: "Chicken, Prawn, Boiled Rice, Coconut Rice, Egg Fried Rice, Hot",
  },
  {
    id: 23,
    title: "Asia Villa Special Fried Rice (Mild)",
    description:
      "Indulge in the culinary artistry of our AV Signature Special Fried Rice, a vibrant medley of vegetables, fragrant garlic, spring onions, shallots, and crowned with a fried egg on top. Available exclusively at Asia Villa.",
    category: "Curry and Rice Dishes (Main)",
    image: "/Photos/Menu01042024/curry_asia_villa_special_fried_rice.jpeg",
    vegan: false,
    vegetarian: false,
    contains: "eggs, gluten, milk, soybeans",
    options: "Chicken, Prawn, Beef, Tofu, Hot",
  },
  {
    id: 24,
    title: "Thai Green Curry (Spicy)",
    description:
      "Savour the exquisite taste of our Spicy Thai Green Curry, a harmonious blend of creamy coconut milk, tender bamboo shoots, succulent aubergine, crisp green beans, vibrant carrots, and colourful green and red peppers. Delight in the vibrant flavours that dance on your plate.",
    category: "Curry and Rice Dishes (Main)",
    image: "/Photos/Menu01042024/curry_thai_green_curry.jpeg",
    vegan: true,
    vegetarian: true,
    contains: "",
    options:
      "Chicken, Prawn, Beef, Tofu (Vegetarian), Boiled Rice, Egg Fried Rice, Coconut Rice, Vegan",
  },
  {
    id: 25,
    title: "Chicken Teriyaki (Served with Rice)",
    description:
      "Indulge in our Chicken Teriyaki, featuring tender grilled chicken bathed in a sweet and tangy, sticky teriyaki sauce. This flavourful masterpiece is complemented by a colourful blend of cabbage, carrots, edamame beans, and a sprinkle of sesame seeds, creating a harmonious symphony of tastes and textures that will leave your palate craving for more.",
    category: "Curry and Rice Dishes (Main)",
    image: "/Photos/Menu01042024/curry_chicken_teriyaki.jpeg",
    vegan: false,
    vegetarian: false,
    contains: "gluten, sesame, soybeans",
    options: "Boiled Rice, Egg Fried Rice, Coconut Rice, Hot",
  },
  {
    id: 26,
    title: "Japanese Katsu Curry (Mild)",
    description:
      "Crispy fried cutlet served with a rich, aromatic curry sauce, thoughtfully spiced with traditional Japanese seasonings and infused with carrots, onions, and tender potatoes. All of this deliciousness rests atop a bed of steaming rice.",
    category: "Curry and Rice Dishes (Main)",
    image: "/Photos/Menu01042024/curry_japanese_katsu.jpeg",
    vegan: false,
    vegetarian: false,
    contains: "gluten, soybeans",
    options:
      "Crispy Chicken, Prawn Tempura, Boiled Rice, Egg Fried Rice, Coconut Rice, Hot",
  },
  {
    id: 27,
    title: "Thai Red Curry (Spicy)",
    description:
      "Spicy Thai red curry, coconut milk with bamboo shoots, aubergine, red & green peppers and fine beans.",
    category: "Curry and Rice Dishes (Main)",
    image: "/Photos/Menu01042024/curry_thai_red_curry.jpeg",
    vegan: false,
    vegetarian: true,
    contains: "",
    options:
      "Chicken, Prawn, Beef, Tofu (Vegetarian), Boiled Rice, Egg Fried Rice, Coconut Rice, Hot",
  },
  {
    id: 28,
    title: "Thai Red Curry Duck (Spicy)",
    description:
      "Spicy Thai red curry, coconut milk with red & green peppers, pineapple and roasted duck. Contains shrimp.",
    category: "Curry and Rice Dishes (Main)",
    image: "/Photos/Menu01042024/curry_thai_red_curry.jpeg",
    vegan: false,
    vegetarian: false,
    contains: "crustaceans",
    options: "Boiled Rice, Egg Fried Rice, Coconut Rice, Hot",
  },
  {
    id: 29,
    title: "Nasi Goreng (Indonesia Favourite) Medium",
    description:
      "Experience the heat and zest of our Spicy Nasi Goreng, a tantalizing blend of lemongrass, galangal, and shrimp paste. Paired with mixed vegetables, a fried egg, crowned with red chilli and shallots, it's an explosive flavour journey.",
    category: "Curry and Rice Dishes (Main)",
    image: "/Photos/Menu01042024/curry_nasi_goreng.jpeg",
    vegan: false,
    vegetarian: false,
    contains: "crustaceans, eggs, gluten, soybeans, sesame",
    options: "Chicken, Prawn, Beef, Tofu with Egg, Hot",
  },
  {
    id: 30,
    title: "Pad Krapao (Spicy)",
    description:
      "Thai style spicy flavours of our Pad Krapao, infused with fragrant mint, fiery chilies, crisp fine beans, carrots, onions, and a colourful blend of green and red peppers. A delectably fried egg crowns this dish, offering tastes and textures that will ignite your taste buds.",
    category: "Curry and Rice Dishes (Main)",
    image: "/Photos/Menu01042024/curry_pakapong.jpeg",
    vegan: true,
    vegetarian: true,
    contains: "eggs, fish, gluten, sesame, milk",
    options: "Chicken, Prawn, Boiled Rice, Coconut Rice, Egg Fried Rice, Vegan",
  },
  {
    id: 31,
    title: "Pad Thai (Thai Favourite) Mild",
    description:
      "Savour the taste of Thailand with our Pad Thai Noodles. Wok-fried flat rice noodles meet a mild spicy embrace, harmonizing with egg, fish sauce, and a zesty lime wedge. Fresh spring onions, crisp carrots, and crunchy bean sprouts add a delightful contrast of textures, while a side of crushed peanuts brings a nutty finish to this classic Thai favourite.",
    category: "Noodle Dishes (Main)",
    image: "/Photos/Menu01042024/noodle_dish_pad_thai.jpeg",
    vegan: false,
    vegetarian: false,
    contains: "eggs, fish, peanuts",
    options: "Chicken, Prawn, Beef, Hot",
  },
  {
    id: 32,
    title: "Chilli Yaki Udon (Japanese favourite) Spicy",
    description:
      "Japanese-inspired flavours of our Spicy Udon Stir-Fry. Bursting with eggs, carrots, bean sprouts, green & red peppers, garlic, onions, and fresh spring onions, this dish is elevated with a zesty prawn chili paste, delivering a harmonious symphony of tastes and textures.",
    category: "Noodle Dishes (Main)",
    image: "/Photos/Menu01042024/noodle_dish_chiil_yaki_udon.jpeg",
    vegan: true,
    vegetarian: true,
    contains: "eggs, fish, gluten, sesame, soybeans",
    options: "Chicken, Prawn, Beef, Hot, Vegan",
  },
  {
    id: 33,
    title: "Chow Mein (Hong Kong-Style) Mild",
    description:
      "Experience the authentic flavours of Hong Kong with our Chow Mein. Wok-fried to perfection, these noodles are infused with the essence of eggs, carrots, bean sprouts, cabbage, and spring onions. Enhanced by a medley of garlic, onions, and a hint of sesame oil, it's a delightful taste of Hong Kong in every bite.",
    category: "Noodle Dishes (Main)",
    image: "/Photos/Menu01042024/noodle_dish_chow_mein.jpeg",
    vegan: true,
    vegetarian: true,
    contains: "eggs, gluten, sesame, milk, soybeans",
    options: "Chicken, Prawn, Beef, Hot, Vegan",
  },
  {
    id: 34,
    title: "Singapore Noodle (Mild)",
    description:
      "Experience the vibrant flavours of our Singaporean-inspired Stir-Fried Rice Vermicelli, gently kissed with aromatic curry powder. Served with a delightful medley of egg, green and red peppers, onions, garlic, carrots, bean sprouts, and fresh spring onions, it's a harmonious fusion of tastes and textures.",
    category: "Noodle Dishes (Main)",
    image: "/Photos/Menu01042024/noodle_dish_singapore_noodle.jpeg",
    vegan: false,
    vegetarian: false,
    contains: "eggs, sesame, milk, gluten, soybeans",
    options: "Chicken, Prawn, Beef, Hot",
  },
  {
    id: 35,
    title: "Pad See Ew (Medium)",
    description:
      "Savour the subtle excitement of our wok-fried flat rice noodles. They're expertly blended with eggs, dark soy sauce, sesame oil, tender carrots, fresh broccoli, and the delightful hues of red and green peppers. All of this is gently kissed with a mild spice, creating a harmonious and flavourful dish that's perfect for those who prefer a gentler heat.",
    category: "Noodle Dishes (Main)",
    image: "/Photos/Menu01042024/noodle_dish_pad_see_ew.jpeg",
    vegan: true,
    vegetarian: true,
    contains: "eggs, molluscs, sesame, soybeans, gluten",
    options: "Chicken, Prawn, Beef, Hot,Vegan",
  },
  {
    id: 36,
    title: "Scissor (Burmese Favourite) (Spicy)",
    description:
      "Spicy wok fried flat rice noodle with egg, garlic, fish sauce, prawn chilli, vinegar, carrot, beansprout, cabbage, peppers, spring onion, and chilli bean paste.",
    category: "Noodle Dishes (Main)",
    image: "/Photos/Menu01042024/noodle_dish_burmese_scissor.jpeg",
    vegan: false,
    vegetarian: false,
    contains: "eggs, fish, gluten, soybeans",
    options: "Chicken, Prawn, Beef, Hot",
  },
  {
    id: 37,
    title: "Pad Kee Mao (Spicy)",
    description:
      "Spicy wok fried flat rice noodle dish with egg, garlic, fish sauce, dark soy, red &green peppers, mushroom, aubergine, cabbage, green beans, mint/ basil, chillies, lemon juice and finely chopped lemongrass.",
    category: "Noodle Dishes (Main)",
    image: "/Photos/Menu01042024/noodle_dish_pad_kee_mao.jpeg",
    vegan: false,
    vegetarian: false,
    contains: "eggs, fish, gluten, soybeans",
    options: "Chicken, Prawn, Beef, Hot",
  },
  {
    id: 38,
    title: "Egg Fried Rice",
    description:
      "Softly scrambled eggs, rich soy sauce, aromatic garlic, fresh spring onions, and crispy fried onions. Each bite is a mouth-watering and satisfying experience.",
    category: "Side Dishes",
    image: "/Photos/Menu01042024/side_dish_egg_fried_rice.jpeg",
    vegan: false,
    vegetarian: false,
    contains: "eggs, gluten, milk, soybeans",
    options: "Hot",
  },
  {
    id: 39,
    title: "Coconut Rice",
    description:
      "This isn't your average boiled rice. It's an extraordinary blend of rice grains delicately cooked with lightly sweetened coconut milk and a touch of salt.",
    category: "Side Dishes",
    image: "/Photos/Menu01042024/side_dish_coconut_rice.jpeg",
    vegan: true,
    vegetarian: true,
    contains: "",
    options: "Vegan",
  },
  {
    id: 101,
    title: "Jasmine Rice",
    description:
      "Discover fragrant jasmine rice, the ideal companion for a variety of dishes, from hearty curries to flavourful stir-fries. Its comforting a comforting and satisfying addition to your meals.",
    category: "Side Dishes",
    image: "/Photos/Menu01042024/side_dish_jasmine_rice.jpeg",
    vegan: true,
    vegetarian: true,
    contains: "",
    options: "Vegan",
  },
  {
    id: 40,
    title: "Katsu Curry Sauce (Vegan)",
    description: "Katsu curry sauce with bit of onions and carrots.",
    category: "Side Dishes",
    image: "/Photos/Menu01042024/side_dish_katsu_curry.jpeg",
    vegan: true,
    vegetarian: true,
    contains: "gluten, soybeans",
    options: "Vegan",
  },

  {
    id: 42,
    title: "Mix Vegetable (Vegetarian)",
    description:
      "To delight your palate, we present our Mixed Vegetable Stir-Fry – a vibrant ensemble of red and green peppers, broccoli, carrots, green beans, mushrooms, cabbage, tomatoes, beansprouts, garlic, onions, and spring onions, all kissed with the subtle essence of sesame oil and soy sauce.",
    category: "Side Dishes",
    image: "/Photos/Menu01042024/side_dish_mixed_vegetable.jpeg",
    vegan: true,
    vegetarian: true,
    contains: "gluten,  soybeans, sesame",
    options: "Vegan",
  },
  {
    id: 102,
    title: "Stir Fried Broccoli with Oyster Sauce",
    description:
      "A stir-fry harmonious medley: Tender broccoli, sweet carrots, aromatic garlic , spring onions, all united with luscious oyster sauce and a delicate touch of sesame oil.",
    category: "Side Dishes",
    image: "/Photos/Menu01042024/side_dish_stir_fried_brocolli.jpeg",
    vegan: true,
    vegetarian: true,
    contains: "gluten, soybeans, sesame",
    options: "Vegan",
  },

  {
    id: 44,
    title: "Mango and Passion Fruit (Thai Favourite)",
    description:
      "Mango torte on a sponge base, finished with a passion fruit glaze.",
    category: "Desserts",
    image: "/Photos/Menu01042024/dessert_mango_passion.jpeg",
    vegan: false,
    vegetarian: true,
    contains: "eggs, milk, gluten",
    options: "",
  },
  {
    id: 45,
    title: "White Chocolate Pyramid",
    description:
      "Success biscuit, white chocolate mousse, caramel cream, and white chocolate icing.",
    category: "Desserts",
    image: "/Photos/Menu01042024/dessert_white_chocolate_pyramid.jpeg",
    vegan: false,
    vegetarian: true,
    contains: "eggs, fish, gluten, milk, nuts, soybeans",
    options: "",
  },
  {
    id: 46,
    title: "Vanilla Ice-Cream Mochi (2 pcs)",
    description:
      "Japanese style soft, slightly chewy and sweet rice dough filled with vanilla ice cream in the center.",
    category: "Desserts",
    image: "/Photos/Menu01042024/dessert_vanilla_mochi.jpeg",
    vegan: false,
    vegetarian: true,
    contains: "milk, soybeans",
    options: "",
  },
  {
    id: 47,
    title: "Coke Can (330 ml)",
    category: "Soft Drinks",
    description: "Soft Drinks 330ml",
    image: "/Photos/Menu01042024/drink_coke.jpeg",
    vegan: true,
    vegetarian: true,
    contains: "",
    options: "",
  },
  {
    id: 48,
    title: "Fanta Orange Can (330 ml)",
    category: "Soft Drinks",
    description: "Soft Drinks 330ml",
    image: "/Photos/Menu01042024/drink_fanta.jpeg",
    vegan: true,
    vegetarian: true,
    contains: "",
    options: "",
  },
  {
    id: 49,
    title: "Diet Coke Can (330 ml)",
    category: "Soft Drinks",
    description: "Soft Drinks 330ml",
    image: "/Photos/Menu01042024/drink_diet_coke.jpeg",
    vegan: true,
    vegetarian: true,
    contains: "",
    options: "",
  },
  {
    id: 50,
    title: "7UP Can (330 ml)",
    category: "Soft Drinks",
    description: "Soft Drinks 330ml",
    image: "/Photos/Menu01042024/drink_7up.jpeg",
    vegan: true,
    vegetarian: true,
    contains: "",
    options: "",
  },
  {
    id: 51,
    title: "Still Water (330ml)",
    category: "Soft Drinks",
    description: "Soft Drinks 330ml",
    image: "/Photos/Menu01042024/drink_still.jpeg",
    vegan: true,
    vegetarian: true,
    contains: "",
    options: "",
  },
  {
    id: 52,
    title: "Sparkling Water (330ml)",
    category: "Soft Drinks",
    description: "Soft Drinks 330ml",
    image: "/Photos/Menu01042024/drink_sparkling.jpeg",
    vegan: true,
    vegetarian: true,
    contains: "",
    options: "",
  },
  {
    id: 53,
    title: "Chilli Oil",
    category: "Extra Sauce",
    description: "",
    image: "/Photos/Menu01042024/extra_chilli_oil.jpeg",
    vegan: true,
    vegetarian: true,
    contains: "",
    options: "",
  },
  {
    id: 54,
    title: "Sweet Chilli Sauce",
    category: "Extra Sauce",
    description: "",
    image: "/Photos/Menu01042024/extra_sweet_chilli.jpeg",
    vegan: true,
    vegetarian: true,
    contains: "",
    options: "",
  },
  {
    id: 55,
    title: "Soy Sauce",
    category: "Extra Sauce", // You can adjust the category if needed
    description: "",
    image: "/Photos/Menu01042024/extra_soy.jpeg",
    vegan: true, // Note: Soy sauce may not be universally considered vegan due to potential filtering agents.
    vegetarian: true,
    contains: "sesame, soybeans",
    options: "",
  },
  {
    id: 56,
    title: "Crushed Peanuts",
    category: "Extra Sauce", // You can adjust the category if needed
    description: "",
    image: "/Photos/Menu01042024/extra_crush_peanut.jpeg",
    vegan: false, // Peanuts are not vegan.
    vegetarian: true,
    contains: "peanuts, soybeans",
    options: "",
  },
];

export default newMenu;
